import axios from 'axios';

/** Resolve URLs de upload (/uploads/...) ou URLs absolutas para exibição no browser. */
export const getAssetUrl = (path: string): string => {
  if (!path) return '';
  const trimmed = path.trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;

  const apiBase = axios.defaults.baseURL || 'http://localhost:5000/api';
  const origin = apiBase.replace(/\/api\/?$/, '');

  if (trimmed.startsWith('/')) {
    return origin ? `${origin}${trimmed}` : trimmed;
  }
  return origin ? `${origin}/${trimmed}` : `/${trimmed}`;
};

export const applyFaviconToDocument = (faviconPath?: string) => {
  const fallback = `${process.env.PUBLIC_URL || ''}/favicon.ico`;
  const href = faviconPath?.trim() ? getAssetUrl(faviconPath.trim()) : fallback;

  let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
};
